import { Stack } from '@mui/material';
import {
  IconButton,
  InputAdornment,

  TextField,
  Typography,

} from '@material-ui/core';

import React from 'react';








export const FormTextInput = (props) => {
  let {
    label,
    endAdornment,
    startAdornment,
    onChange,
    disabled,
    required,
    variant = 'outlined',
    endAdornmentOnClick = () => {},
    startAdornmentOnClick = () => {},
    value,
    ...rest
  } = props;

  const handleChange = (event) => {
    if (onChange !== undefined) onChange(event);
  };

  return (
    React.createElement(Stack, {
      flexDirection: "column",
      alignItems: "stretch",
      gap: 1,
      justifyContent: "start",}
    
      , label && (
        React.createElement(Typography, {
          variant: "body1",
          style: { fontWeight: 'bold' },
          color: disabled ? 'inherit' : 'textPrimary',
          role: "title",}
        
          , label, " " , required && '*'
        )
      )

      , React.createElement(TextField, {
        value: value ?? '',
        variant: variant ,
        onChange: handleChange,
        InputProps: {
          disabled,
          startAdornment: startAdornment && (
            React.createElement(InputAdornment, { position: "start",}
              , React.createElement(IconButton, {
                color: "primary",
                onClick: () => startAdornmentOnClick(value),}
              
                , startAdornment
              )
            )
          ),
          endAdornment: endAdornment && (
            React.createElement(InputAdornment, { position: "end",}
              , React.createElement(IconButton, {
                color: "primary",
                onClick: () => endAdornmentOnClick(value),}
              
                , endAdornment
              )
            )
          ),
        },
        ...rest,}
      )
    )
  );
};
